export default function _isNumber(x) {
	return Object.prototype.toString.call(x) === '[object Number]';
}


// WEBPACK FOOTER //
// ./src/common/bare-metal/private/isNumber.js